import { loader } from 'graphql.macro'

export default function associateFeeTypesToQuickbooks ({ dataLoaders, variables }) {
  const { input } = variables
  const schema = loader('./associateFeeTypesToQbo.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, { input })
}
